(() => {
  const morphEl = document.querySelector('[data-homepage-logo-morph]');
  const startEl = document.querySelector('[data-homepage-logo-start]');
  const endEl = document.querySelector('[data-homepage-logo-end]');

  function markReady() {
    if (morphEl) morphEl.classList.add('homepage-desktop-logo-morph--ready');
  }

  if (!morphEl || !startEl || !endEl) {
    markReady();
    return;
  }

  const mq = window.matchMedia('(min-width: 990px)');

  const LOGO_MIN_WIDTH_PX = 140;
  const FINAL_LOGO_TOP_OFFSET_PX = 20;

  let morphScrollBaseline = 0;
  let scrollRange = 1;
  let padXPx = 24;

  const lerp = (a, b, t) => a + (b - a) * t;

  const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n));

  function readRect(el) {
    const r = el.getBoundingClientRect();
    return {
      left: r.left,
      top: r.top,
      width: r.width,
      height: r.height,
    };
  }

  function refreshPadX() {
    const v =
      getComputedStyle(document.documentElement).getPropertyValue('--content-pad-x-desktop').trim() ||
      '1.5rem';
    const tmp = document.createElement('div');
    tmp.style.cssText =
      'position:absolute;left:-9999px;top:0;width:0;height:0;padding-left:' +
      v +
      ';visibility:hidden;pointer-events:none;';
    document.body.appendChild(tmp);
    padXPx = parseFloat(getComputedStyle(tmp).paddingLeft) || 24;
    tmp.remove();
  }

  function heroRectFallback(end) {
    const iw = document.documentElement.clientWidth;
    const w = Math.max(200, iw - 2 * padXPx);
    const h = w * (21 / 140);
    return {
      left: padXPx,
      top: Math.max(0, end.top - h * 0.15),
      width: w,
      height: h,
    };
  }

  function computeScrollRange() {
    refreshPadX();
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const main = document.getElementById('MainContent');
    const wrapper = document.querySelector('.main-content-wrapper');
    if (main && wrapper) {
      const mainTopDoc = main.getBoundingClientRect().top + scrollY;
      const wrapperTopDoc = wrapper.getBoundingClientRect().top + scrollY;
      morphScrollBaseline = Math.max(0, wrapperTopDoc);
      scrollRange = Math.max(80, mainTopDoc - wrapperTopDoc);
      return;
    }
    if (main) {
      morphScrollBaseline = 0;
      scrollRange = Math.max(80, main.getBoundingClientRect().top + scrollY);
      return;
    }
    morphScrollBaseline = 0;
    scrollRange = Math.max(120, startEl.offsetHeight);
  }

  function scrollYToProgress(scrollY) {
    return clamp((scrollY - morphScrollBaseline) / scrollRange, 0, 1);
  }

  function clearMorphStyles() {
    morphEl.style.removeProperty('position');
    morphEl.style.removeProperty('left');
    morphEl.style.removeProperty('top');
    morphEl.style.removeProperty('width');
    morphEl.style.removeProperty('right');
    morphEl.style.removeProperty('height');
    morphEl.style.removeProperty('z-index');
    morphEl.classList.remove('homepage-desktop-logo-morph--active');
  }

  function applyMorphAtProgress(p) {
    if (!mq.matches) {
      clearMorphStyles();
      markReady();
      return;
    }

    morphEl.classList.add('homepage-desktop-logo-morph--active');

    const t = clamp(p, 0, 1);
    let start = readRect(startEl);
    const end = readRect(endEl);

    if (start.width < 8 || start.height < 8) {
      start = heroRectFallback(end);
    }

    const endW = Math.max(LOGO_MIN_WIDTH_PX, end.width);
    const iw = document.documentElement.clientWidth;
    const maxContentW = Math.max(LOGO_MIN_WIDTH_PX, iw - 2 * padXPx);

    let width = Math.max(LOGO_MIN_WIDTH_PX, Math.min(maxContentW, lerp(start.width, endW, t)));
    let left = lerp(start.left, end.left, t);
    left = clamp(left, padXPx, iw - padXPx - width);

    const startTop = Math.max(0, start.top);
    const endTop = end.top + FINAL_LOGO_TOP_OFFSET_PX;
    const top = Math.max(0, lerp(startTop, endTop, t));

    morphEl.style.setProperty('position', 'fixed', 'important');
    morphEl.style.left = `${left}px`;
    morphEl.style.top = `${top}px`;
    morphEl.style.width = `${width}px`;
    morphEl.style.right = 'auto';
    morphEl.style.height = 'auto';
    morphEl.style.zIndex = '500';

    markReady();
  }

  function syncMorphToScroll() {
    try {
      if (!mq.matches) {
        clearMorphStyles();
        markReady();
        return;
      }
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      applyMorphAtProgress(scrollYToProgress(scrollY));
    } catch (e) {
      clearMorphStyles();
      markReady();
    }
  }

  function onResize() {
    computeScrollRange();
    syncMorphToScroll();
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      computeScrollRange();
      try {
        syncMorphToScroll();
      } catch (e) {
        clearMorphStyles();
        markReady();
      }
    });
  });

  window.addEventListener('scroll', syncMorphToScroll, { passive: true });
  window.addEventListener('resize', onResize);

  mq.addEventListener('change', () => {
    computeScrollRange();
    syncMorphToScroll();
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready
      .then(() => {
        computeScrollRange();
        syncMorphToScroll();
      })
      .catch(() => {
        computeScrollRange();
        syncMorphToScroll();
      });
  }
})();
